var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMCuisse1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 177,
    viewBox: "0 0 117 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.387 177C105.387 161.616 108.359 77.5921 105.766 49.1571C103.174 20.7222 105.983 10.711 105.983 6.67572e-06",
    stroke: "#909090",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.673 71.7056C115.673 71.7056 115.673 100.891 115.673 135.885",
    stroke: "#909090",
    strokeMiterlimit: 10,
    strokeDasharray: "3.97 3.97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7872 177C10.7872 161.616 7.81509 77.5921 10.4073 49.1571C12.9996 20.7222 10.1909 10.711 10.1908 6.67572e-06",
    stroke: "#909090",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 71.7056C0.5 71.7056 0.5 100.891 0.5 135.885",
    stroke: "#909090",
    strokeMiterlimit: 10,
    strokeDasharray: "3.97 3.97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMCuisse1);
export default __webpack_public_path__ + "static/media/M-CUISSE_1.1d3da51032c3663169cde858e4c5bce2.svg";
export { ForwardRef as ReactComponent };